// ================================================================
// WebAuthn stub — passkey authentication
// ================================================================
export function isWebAuthnSupported() { return false; }
export function isPasskeySupported() { return false; }
export function isBiometricAvailable() { return Promise.resolve(false); }
export function registerPasskey() { return Promise.resolve(null); }
export function authenticateWithPasskey() { return Promise.resolve(null); }
export function hasLocalPasskeys() { return false; }
